import { getCookieIgnoreHostPermissionErrors } from './cookies'
import { GobyApiCookieType } from './enums'
import { apiOrigin } from '../consts/urlConsts'

const CSRF_HEADER = 'X-CSRF-TOKEN'

export async function getAccessTokenCookie(): Promise<
  chrome.cookies.Cookie | null | undefined
> {
  if (!apiOrigin) {
    return undefined
  }

  return getCookieIgnoreHostPermissionErrors({
    name: GobyApiCookieType.ACCESS_JWT,
    url: apiOrigin,
  })
}

export async function getAccessToken(): Promise<string | undefined> {
  const cookie = await getAccessTokenCookie()
  return cookie?.value
}

export async function getHasValidAccessToken(): Promise<boolean> {
  const cookie = await getAccessTokenCookie()

  if (!cookie) {
    return false
  }

  // expirationDate is in seconds; Date.now() is in ms
  return !cookie.expirationDate || cookie.expirationDate > Date.now() / 1000
}

export async function getRefreshTokenCookie(): Promise<
  chrome.cookies.Cookie | null | undefined
> {
  if (!apiOrigin) {
    return undefined
  }

  return getCookieIgnoreHostPermissionErrors({
    name: GobyApiCookieType.REFRESH_JWT,
    url: apiOrigin,
  })
}

export async function getRefreshToken(): Promise<string | undefined> {
  const cookie = await getRefreshTokenCookie()
  return cookie?.value
}

export async function getHasValidRefreshToken(): Promise<boolean> {
  const cookie = await getRefreshTokenCookie()

  if (!cookie) {
    return false
  }

  // expirationDate is in seconds; Date.now() is in ms
  return !cookie.expirationDate || cookie.expirationDate > Date.now() / 1000
}

export async function getAccessTokenCsrf(): Promise<string | undefined> {
  if (!apiOrigin) {
    return undefined
  }

  const cookie = await getCookieIgnoreHostPermissionErrors({
    name: GobyApiCookieType.ACCESS_JWT_CSRF,
    url: apiOrigin,
  })

  return cookie?.value
}

export async function getRefreshTokenCsrf(): Promise<string | undefined> {
  if (!apiOrigin) {
    return undefined
  }

  const cookie = await getCookieIgnoreHostPermissionErrors({
    name: GobyApiCookieType.REFRESH_JWT_CSRF,
    url: apiOrigin,
  })

  return cookie?.value
}

export async function getJwtCsrfHeader(
  tokenType: 'access' | 'refresh',
): Promise<[string, string] | [null, null]> {
  const token =
    tokenType === 'access'
      ? await getAccessTokenCsrf()
      : await getRefreshTokenCsrf()

  if (!token) {
    return [null, null]
  }

  return [CSRF_HEADER, token]
}
